import React from 'react'
// import { graphql, useStaticQuery, Link } from 'gatsby'
// import { StaticImage } from 'gatsby-plugin-image'
import { Link } from 'gatsby'
import Layout from '../components/core/uxdx/layout'
import MetaData from '../components/core/metaData'
import { ChatAlt2Icon, MailIcon, MicrophoneIcon, UserGroupIcon } from '@heroicons/react/outline'

function ContactChannel({ icon: Icon, children, href }) {
  const content = (
    <>
      <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-white text-gray-500 shadow-sm ring-1 ring-gray-200/80">
        <Icon className="h-5 w-5" aria-hidden="true" />
      </span>
      <span className="min-w-0 text-base font-medium text-gray-900">{children}</span>
    </>
  )

  if (href) {
    return (
      <a
        href={href}
        className="flex items-center gap-4 rounded-2xl bg-gray-100 px-5 py-4 transition-colors hover:bg-gray-200/80"
      >
        {content}
      </a>
    )
  }

  return <div className="flex items-center gap-4 rounded-2xl bg-gray-100 px-5 py-4">{content}</div>
}

const Contact = () => {
  return (
    <Layout>
      <MetaData
        image="images/metaImages/metaContact.jpeg"
        title="Contact us"
        description="UXDX is here to help. Whether you want to share information, speak at an event, or inquire about sponsorship, we are a click away. Chat with us live or email us: connect@uxdx.com"
      />

      <section className="w-full py-8 sm:py-10">
        <div className="max-w-screen-2xl mx-auto px-6">
          <div className="flex w-full flex-col gap-6 lg:flex-row lg:items-start lg:justify-between">
            <h1 className="text-[clamp(3.5rem,11vw,8.5rem)] font-light uppercase leading-[0.9] tracking-tighter text-gray-900">
              Contact
            </h1>
            <p className="max-w-sm font-mono text-[10px] uppercase leading-relaxed tracking-[0.15em] text-gray-500 sm:text-xs lg:max-w-xs lg:pt-2 lg:text-right text-balance">
              Whatever you need, we&apos;re here.
            </p>
          </div>
        </div>
      </section>

      <section className="max-w-screen-2xl mx-auto px-6 pb-16 sm:pb-24">
        <div className="grid gap-12 lg:grid-cols-2 lg:items-start lg:gap-16">
          <div className="space-y-4">
            <ContactChannel icon={ChatAlt2Icon}>
              Chat with us in the box at the bottom right of the screen
            </ContactChannel>
            <ContactChannel icon={MailIcon} href="mailto:connect@uxdx.com">
              connect@uxdx.com
            </ContactChannel>
          </div>

          <div className="grid gap-6">
            <div className="flex h-full flex-col rounded-2xl border border-gray-200 bg-gray-50 p-8 shadow-sm">
              <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-gray-100 text-gray-900">
                <MicrophoneIcon className="h-6 w-6" aria-hidden="true" />
              </span>
              <h2 className="mt-5 text-2xl font-light tracking-[-0.035em] text-gray-950 sm:text-3xl">Want to Speak?</h2>
              <div className="mt-3 flex-1">
                <p className="text-lg text-gray-500">
                  You can find all of the speaking details and how to apply to speak.
                </p>
              </div>
              <div className="pt-6">
                <Link
                  to="/speak"
                  type="button"
                  className="inline-flex items-center gap-2 rounded-full bg-black px-5 py-2 text-sm font-medium whitespace-nowrap text-white transition-colors hover:bg-gray-900"
                >
                  Apply to Speak
                </Link>
              </div>
            </div>

            <div className="flex h-full flex-col rounded-2xl border border-gray-200 bg-gray-50 p-8 shadow-sm">
              <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-gray-100 text-gray-900">
                <UserGroupIcon className="h-6 w-6" aria-hidden="true" />
              </span>
              <h2 className="mt-5 text-2xl font-light tracking-[-0.035em] text-gray-950 sm:text-3xl">
                Want to partner with us?
              </h2>
              <div className="mt-3 flex-1">
                <p className="text-lg text-gray-500">
                  You can find all of our partnership information and how to get in touch with us.
                </p>
              </div>
              <div className="pt-6">
                <Link
                  to="/partner"
                  type="button"
                  className="inline-flex items-center gap-2 rounded-full bg-black px-5 py-2 text-sm font-medium whitespace-nowrap text-white transition-colors hover:bg-gray-900"
                >
                  Discover more
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  )
}
// ;<div className="mt-9">
//   <div className="mt-6 flex">
//     <div className="flex-shrink-0">
//       <MailIcon className="h-6 w-6 text-gray-400" aria-hidden="true" />
//     </div>
//     <div className="ml-3 text-base text-gray-500">
//       <a href="mailto:connect@uxdx.com">connect@uxdx.com</a>
//     </div>
//   </div>
// </div>

export default Contact
